import { useDispatch, useSelector } from "react-redux";
import {
  EndPointUserDetails,
  LOGOUT_API
} from "../../services/common/endpoints";

import { useFetcher, useLocation, useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import { useEffect, useState } from "react";
import {
  GetCacheKey,
  loginencrypt,
  setItem,
  getItem,getItemOfSessionStorage
} from "../../services/common/utils";
import {
  setcustomerprofile,
  setrnuserdetails,
  setSelectedNumber,
  settoken,
  setRatePlanType, 
  setLoginType,
  setISB2BCPRNumber,
  resetUserData,
  setIsWifiCase,
  setUserLoggedInNumber
} from "../../reducer/actions";
import {
  resetAppSliceReduxData
} from "../../reducer/appSlice";
import {
  resetAssistantData
} from "../../reducer/assistantSlice";
import {
  resetNojoomReduxData
} from "../../reducer/nojoomSlice";
import {
  resetRoamingReduxData
} from "../../reducer/roamingSlice";
import {
  resetUtilityReduxData
} from "../../reducer/utilitySlice";
import { TOKEN_ID,SELECTED_LANG } from "../../services/common/Constants";
import { RC4Decrypt, RC4DecryptHE } from '../../services/common/RC4EncDec';
import { consoleLog } from "../../services/common/utils";
import {isB2BCPRNumber} from "../../services/common/CommonUtils"
import MessageModal from "../../components/common/bottom-modal-message";
import { t } from "i18next";
import { setItemInSessionStorage } from "../../services/common/utils";
import { resetCdrReduxData } from "../../reducer/cdrSlice";
import Loadingcomponent from "../../components/loader/loadingcomponent";
const EnrichmentComponent = ()=>{
  
    //const tokenid = useSelector((state) => state?.userdata?.value?.tokenid);
    const tokenid = window.sessionStorage.getItem("authkey");
    try{sessionStorage.removeItem("hepage");}catch{}
    const [loggedIn, setLoggedIn] = useState(false);
    const [dynPageName, setdynPageName] = useState("");
    const [enableLogoutApi, setenableLogoutApi] = useState(false);
    const [cdrToken, setcdrToken] = useState("");
    const [enablevalidatetoken, setenablevalidatetoken] = useState(false);
    const [crdLoading, setCrdLoading] = useState(false); 
    const dispatch = useDispatch();
    const navigate = useNavigate();
    let _encryptVal = "";
    try{
      const url = useLocation().search;
      _encryptVal = new URLSearchParams(url).get('enc');
    }catch(e){}

    const { data: { data } = {} } = useQuery(["", LOGOUT_API, {}, {}, false], {
      enabled: enableLogoutApi,
      retry: false,
    });

const userDetailsApi = useQuery(
    [
     '',
      "customerprofile/get",
      { source: "homepage", sec: "splash" },
      {},
    ],
    {
      retry: false,
      retryOnMount: true,
      enabled: loggedIn,
      staleTime:0,
      cacheTime:0
    }
  );

  const rnuserdetails = useQuery(
    [
      '',
      EndPointUserDetails.url,
      EndPointUserDetails.data,
      {},
    ],
    {
      retry: false,
      retryOnMount: true,
      enabled: loggedIn,
      staleTime:0,
      cacheTime:0
    }
  );

  const validateCDR = useQuery(
    [
     '',
      "pms/validatecdrtoken",
      { enval: cdrToken },
      {},
    ],
    {
      retry: false,
      enabled: enablevalidatetoken,
      staleTime:0,
      cacheTime:0
    }
  );

  const [messagemodal, setMessagemodal] = useState(false)
  useEffect(() => {
    console.log("userdetails success")
    if (userDetailsApi?.isSuccess && userDetailsApi?.data?.data) {
      dispatch(setcustomerprofile(userDetailsApi?.data?.data?.response));
      setItemInSessionStorage("Customerid",userDetailsApi?.data?.data?.response?.CustomerID);
      try{
        var _isB2BCpr = isB2BCPRNumber(userDetailsApi?.data?.data?.response);
        dispatch(setISB2BCPRNumber(_isB2BCpr));
      }catch{}
    }
    if (rnuserdetails?.isSuccess && rnuserdetails?.data?.data) {
      dispatch(setrnuserdetails(rnuserdetails?.data?.data?.response));
      try {
        let _msisdn = "";
        if (rnuserdetails?.data?.data?.response?.msisdn && rnuserdetails?.data?.data?.response?.msisdn.length == 11)
          _msisdn = rnuserdetails?.data?.data?.response?.msisdn.slice(3);
        else
          _msisdn = rnuserdetails?.data?.data?.response?.msisdn
         
          try{
            //FOR HE OR WIFI CASE, IF SSO PROFILE IS NOT EXIST THEN NOT SHOWING SELECTED NUMBER IN THE HEADER DROPDOWN
            //SO TAKING THE NUMBER FROM CUSTOMER PROFILE IF RNUSERDETAILS API WAS FAILED
          if(_msisdn == null || _msisdn == undefined || _msisdn == "" || _msisdn == "undefined"){
            if (userDetailsApi?.data?.data?.response?.Msisdn && userDetailsApi?.data?.data?.response?.Msisdn.length == 11)
            _msisdn = userDetailsApi?.data?.data?.response?.Msisdn.slice(3);
          else
            _msisdn = userDetailsApi?.data?.data?.response?.Msisdn
          }
        }catch{}
        console.log("HE MSISDN:"+_msisdn)
        dispatch(setSelectedNumber(_msisdn));
        dispatch(setUserLoggedInNumber(_msisdn));
        
      } catch (e) { }
    }
    if (rnuserdetails?.isSuccess && userDetailsApi?.isSuccess) {
      try{
        global.userdetails = rnuserdetails?.data?.data?.response;
        global.rateplantype = userDetailsApi?.data?.data?.response.RatePlanType;
        //console.log("global.userdetails:"+JSON.stringify(global.userdetails)+"")
        try{
          dispatch(setRatePlanType(userDetailsApi?.data?.data?.response?.RatePlanType))
          }catch{}
      }catch(e){}
      try{
        if(userDetailsApi?.data?.data?.response?.wbbline){
          dispatch(setIsWifiCase(true));
          dispatch(setLoginType("Wifi"));
          setItemInSessionStorage("loginStatus", "logged in with wifi")
          if(dynPageName !== null && dynPageName !== undefined && dynPageName !== "" && dynPageName !== "undefined"){
            navigate("/"+dynPageName);
             }
             else{
         navigate("/home/index");
         }   
        }
       else  if(dynPageName !== null && dynPageName !== undefined && dynPageName !== "" && dynPageName !== "undefined"){
        dispatch(setLoginType("HE"));
        navigate("/"+dynPageName);
        }
        else{
    navigate("/home/index");
    }   
     }catch{}

    }
  }, [
    userDetailsApi?.data?.data,
    userDetailsApi.isSuccess,
    rnuserdetails?.data?.data,
    rnuserdetails.isSuccess,
  ]);

 useEffect(()=>{
  if (validateCDR?.isSuccess && validateCDR?.data?.data) {
    console.log("CDR TOKEN->"+validateCDR?.data?.data)
    if(validateCDR?.data?.data?.status == "0" && validateCDR?.data?.data?.response != null
    && validateCDR?.data?.data?.response != undefined && validateCDR?.data?.data?.response != ""){
      localStorage.setItem("cdr","true");
      setdynPageName("manage-account");
      dispatch(settoken(validateCDR?.data?.data?.response));
      setItem(TOKEN_ID, validateCDR?.data?.data?.response);
      setLoggedIn(true);
    }else{
      localStorage.setItem("cdr","false");
      navigate("/cdrtimeout");
    }
  }
 },[validateCDR?.data?.data,
  validateCDR.isSuccess]);


  const logout = () => {
    let _lang = getItemOfSessionStorage(SELECTED_LANG);
    dispatch(resetUserData());
    dispatch(resetCdrReduxData());
    setenableLogoutApi(true);
    sessionStorage.clear();
    try{
      var _savedLogin = localStorage.getItem("sl")
      localStorage.clear();
      if(_savedLogin != null && _savedLogin != undefined && _savedLogin != ""
      && _savedLogin != "undefined"){
       localStorage.setItem("sl",_savedLogin)
      }
       }catch{}
    setItem(SELECTED_LANG, _lang);
    navigate("/#");
  };

  const convertTicksToDateTime = (ticks) => {
    // Ticks to milliseconds conversion (1 tick = 100 nanoseconds)
    const ticksInMs = ticks / 10000;
    // The epoch date in the .NET framework (January 1, 0001)
    const epochDate = new Date(0);
    epochDate.setUTCFullYear(1);
    // Calculate the date and time from ticks
    const date = new Date(epochDate.getTime() + ticksInMs);
    return date;
};

  useEffect(() => {
    try {
       if (tokenid == null || tokenid == undefined || tokenid == "") {
          if(window.location.href.indexOf("?enc") > 0){

           try{
            let _lang = getItemOfSessionStorage(SELECTED_LANG);
            try{
            dispatch(resetUserData());
            dispatch(resetCdrReduxData());
            dispatch(resetAppSliceReduxData());
            dispatch(resetAssistantData());
            dispatch(resetNojoomReduxData());
            dispatch(resetRoamingReduxData());
            dispatch(resetUtilityReduxData());
            }catch{}
            sessionStorage.clear();
            localStorage.clear();
            setItem(SELECTED_LANG, _lang);
           }catch{}

            //useLocation and URLSearchParams are not working sometimes in firefox browser, so using native javascript to read URL encrypted value.
          const _encryptVal = window?.location?.href?.substring(window?.location?.href?.indexOf('=')+1);
           console.log("_encryptVal:"+_encryptVal)
           const tokenDecrypt = RC4DecryptHE(_encryptVal)
           console.log("decrypt values:"+tokenDecrypt)
           if(tokenDecrypt){
              const _date = tokenDecrypt?.toString()?.split("|")[0];
              const _heMsisdn = tokenDecrypt?.toString()?.split("|")[1];
              const _tokenid = tokenDecrypt?.toString()?.split("|")[2];
              const _userId = tokenDecrypt?.toString()?.split("|")[3];
              const _pageName = tokenDecrypt?.toString()?.split("|")[4];
              console.log(tokenDecrypt, "tokenDecrypt")
              console.log("$$$$$$$$$$=>_heMsisdn:"+_heMsisdn+",_tokenid:"+_tokenid+",_userId:"+_userId+",_pageName:"+_pageName+"")
               if(_heMsisdn != null && _heMsisdn != undefined && _heMsisdn !=""
               && _tokenid != null && _tokenid != undefined && _tokenid !=""
               && _userId != null && _userId != undefined && _userId !=""){
                console.log("Header msisdn and tokenid is found in HE case")
                try{
                  localStorage.setItem("ihe","true");
                  if(_pageName != null && _pageName != undefined && _pageName !=""){
                    setdynPageName(RC4Decrypt(_pageName));
                 }
                 }catch{
                 }
                 console.log("Header msisdn and tokenid is found in HE case")
                 dispatch(settoken(_tokenid));
                 setItem(TOKEN_ID, _tokenid);
                 setLoggedIn(true);
               }
               else{
                console.log("Header msisdn and tokenid is not found in HE case")
               }
           }
          }
          else if(window.location.href.indexOf("?cdr") > 0){
            setCrdLoading(true);

            // try{
            //   let _lang = getItemOfSessionStorage(SELECTED_LANG);
            //   try{
            //   dispatch(resetUserData());
            //   dispatch(resetCdrReduxData());
            //   dispatch(resetAppSliceReduxData());
            //   dispatch(resetAssistantData());
            //   dispatch(resetNojoomReduxData());
            //   dispatch(resetRoamingReduxData());
            //   dispatch(resetUtilityReduxData());
            //   }catch{}
            //   sessionStorage.clear();
            //   localStorage.clear();
            //   setItem(SELECTED_LANG, _lang);
            //  }catch{}
            
            const _encryptVal = window?.location?.href?.substring(window?.location?.href?.indexOf('=')+1);
            console.log("CDR->encryptVal:"+_encryptVal)
            setcdrToken(_encryptVal);
            setenablevalidatetoken(true);

          }
       }
       else{
        console.log("moved to tokenid empty case")
        navigate("/home/index");
       }
 } catch (e) {
  console.log("catch section enrichment component")
  }
   }, []);

   if(validateCDR.isLoading || validateCDR.isFetching || crdLoading){
      // return <PageShimmer />
      return <div className="d-flex justify-content-center align-items-center vh-100">
        <Loadingcomponent width={"25%"} />
      </div>
   }

return (<>
{/* <MessageModal show={messagemodal} type="7" message={t('yactowrdywtautwn')} handleConfirm={() => {
  try{
    dispatch(setIsWifiCase(true))
    }catch{}
  if(dynPageName !== null && dynPageName !== undefined && dynPageName !== "" && dynPageName !== "undefined"){
      navigate("/"+dynPageName);
    }else{
      navigate("/home/index");
    }
}} handleCancel={()=> {
  try{
  setMessagemodal(false);
  setenableLogoutApi(true);
  logout()
 }catch{}
}} /> */}
</>)

}

export default EnrichmentComponent;
